import React, { Fragment } from "react";

import {
  ENABLE_LOGIN_TOPBAR,
  ENABLE_EMAIL_LOGIN,
  ENABLE_LOGIN_HOME,
  PRIVACY_PAGE_LINK,
  BASE_URL,
  SECRET_KEY,
  ENABLE_SSO_TOKEN_LOGIN
} from "config";

import { LOGIN_TOUR } from "App/Routes";

import TextInput from "components/shared/Inputs/TextInput";
import PasswordInput from "components/shared/Inputs/PasswordInput";
import urlServices from "services/urlServices";
import TourModalContainer from "components/shared/Tour/TourModal/TourModalContainer";

import LoginPage from "components/Login/LoginPage";

import "./Login.css";

import localize from "lang/localize";

class GrabLoginPage extends LoginPage {
  constructor(props) {
    super(props);
    this.state = {
      showTourModal: false
    };

    this.handleOpenTourModal = this.handleOpenTourModal.bind(this);
    this.handleCloseTourModal = this.handleCloseTourModal.bind(this);
  }

  renderSSOLoginSection() {
    return (
      <form
        className="pure-form"
        action={BASE_URL + "showssologin"}
        method="post"
      >
        <Fragment>
          <input type="hidden" name="secret_key" value={SECRET_KEY} />
          <input type="hidden" name="react" value="true" />
          <input type="hidden" name="callback_id" value="sso" />
          <input
            type="hidden"
            name="use_token"
            value={ENABLE_SSO_TOKEN_LOGIN}
          />

          <div className="pure-g bottommargin">
            <div className="pure-u-1-1 pure-u-sm-1-6" />
            <div className="pure-u-1-1 pure-u-sm-2-3">
              <button
                id="loginButton"
                className={
                  "button fullwidth" +
                  (!!this.props.isSubmitLoading ? " disabled" : " cta")
                }
                type="submit"
                disabled={!!this.props.isSubmitLoading}
              >
                {!!this.props.isSubmitLoading
                  ? localize(
                      "nav_bar_title_generic_loading",
                      this.props.language
                    )
                  : localize("button_login_sso", this.props.language)}
              </button>
            </div>
            <div className="pure-u-1-1 pure-u-sm-1-6" />
          </div>
        </Fragment>
      </form>
    );
  }

  renderLoginFields() {
    if (this.showEmailLogin()) {
      return (
        <Fragment>
          <TextInput
            id="emailInput"
            value={this.props.email}
            onChange={this.props.handleEmailChange}
            onKeyPress={this.handleKeyPress}
            placeholder={localize(
              "login_view_email_placeholder_text",
              this.props.language
            )}
          />
          <PasswordInput
            id="passwordInput"
            value={this.props.password}
            onChange={this.props.handlePasswordChange}
            onKeyPress={this.handleKeyPress}
            placeholder={localize(
              "login_view_password_placeholder_text",
              this.props.language
            )}
          />
          <div className="pure-g">
            <div className="pure-u-1-1 pure-u-sm-1-6" />
            <div className="pure-u-1-1 pure-u-sm-2-3">
              <button
                id="loginButton"
                className={
                  "button fullwidth" +
                  (!!this.props.isSubmitLoading ? " disabled" : " cta")
                }
                type="submit"
                disabled={!!this.props.isSubmitLoading}
              >
                {!!this.props.isSubmitLoading
                  ? localize(
                      "nav_bar_title_generic_loading",
                      this.props.language
                    )
                  : localize("button_login", this.props.language)}
              </button>
            </div>
            <div className="pure-u-1-1 pure-u-sm-1-6" />
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  showEmailLogin() {
    if (ENABLE_EMAIL_LOGIN) {
      return true;
    }

    let enableEmailLogin = false;
    let paramVal = urlServices.getUrlParamValueByKey("test"); //check for ?test=true in URL

    if (paramVal === "true") {
      enableEmailLogin = true;
    }

    return enableEmailLogin;
  }

  renderHelpLinks() {
    return (
      <div className="login-help pure-g">
        <div className="pure-u-sm-1-6" />
        <div className="login-help-link login-help-link-tour pure-u-1-2 pure-u-sm-1-3">
          <a
            href={LOGIN_TOUR}
            className="button inline small"
            rel="noopener noreferrer"
            onClick={e => {
              this.handleOpenTourModal(e);
            }}
          >
            Quick Tour
          </a>
        </div>
        <div className="login-help-link login-help-link-faq pure-u-1-2 pure-u-sm-1-3">
          <a
            href="https://go.grab.com/cybergamification"
            className="button inline small"
            rel="noopener noreferrer"
            target="_blank"
          >
            FAQ Page
          </a>
        </div>
        <div className="pure-u-sm-1-6" />
      </div>
    );
  }

  /**
   * Renders the tour modal container
   */
  renderTourModal() {
    return (
      <TourModalContainer
        showModal={this.state.showTourModal}
        handleCloseModal={this.handleCloseTourModal}
        language={this.props.language}
      />
    );
  }

  /**
   * Opens the tour modal
   * @param {*} event
   */
  handleOpenTourModal(event) {
    event.preventDefault();

    this.setState({
      showTourModal: true
    });
  }

  /**
   * Closes the tour modal
   */
  handleCloseTourModal() {
    this.setState({
      showTourModal: false
    });
  }

  render() {
    if (
      /* checking type is important: showPrivacyAgreement is initialised as null */
      typeof this.props.showPrivacyAgreement === "boolean" &&
      this.props.showPrivacyAgreement === true
    ) {
      return (
        <div className="login-register-container container verticalpadding">
          {this.renderTopbarlessBackButton()}
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
              <h5>
                {localize(
                  "login_view_privacy_policy_updated_title",
                  this.props.language
                )}
              </h5>
              <p>
                {localize("login_agree_to_new_terms_text", this.props.language)}
              </p>
              <div className="bottommargin-30">
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdatePrivacyAgreed}
                    checked={this.props.privacyAgreed}
                  />{" "}
                  {localize(
                    "register_agree_to_gametize_text",
                    this.props.language
                  )}
                  <a
                    className="link default"
                    href={PRIVACY_PAGE_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {localize(
                      "register_privacy_policy_text",
                      this.props.language
                    )}
                  </a>
                  .
                </p>
                <p className="smalltext">
                  <input
                    type="checkbox"
                    onChange={this.props.handleUpdateMarketingConsent}
                    checked={this.props.marketingConsent}
                  />{" "}
                  {localize(
                    "register_marketing_communications_text",
                    this.props.language
                  )}
                </p>
              </div>
              <div className="pure-g bottommargin">
                <div className="pure-u-11-24 pure-u-sm-14-24 pure-u-lg-2-3" />
                <div className="pure-u-13-24 pure-u-sm-10-24 pure-u-lg-1-3">
                  <button
                    className={
                      "button fullwidth " +
                      (this.props.privacyAgreed ? "cta" : "inactive")
                    }
                    onClick={this.props.handlePrivacySubmit}
                    disabled={!this.props.privacyAgreed}
                  >
                    {localize("button_quest_continue", this.props.language)}
                  </button>
                </div>
              </div>
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
        </div>
      );
    } else {
      return (
        <div className="login-register-container container verticalpadding">
          <div className="login-logo" />
          <div className="login-title bottompadding">
            Grab's Cyber Gamification Platform
          </div>
          <div className="login-subtitle bottompadding-30">
            Dive into the Cyber Universe
          </div>
          <div className="innerblock pure-g login-form">
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
            <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
              <form
                className="pure-form"
                onSubmit={this.handlePreSubmit.bind(this)}
              >
                {this.renderLoginFields()}
              </form>
              {this.renderSSOLoginSection()}
              {this.renderHelpLinks()}
            </div>
            <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          </div>
          {this.state.showTourModal && this.renderTourModal()}
        </div>
      );
    }
  }
}

export default GrabLoginPage;
